<script>
	import { format } from "svelte-i18n";
	let { data = [] } = $props();

	const parseDeepObj = (str) => {
		let result = [];
		if(str){
			let vals = str.split(/,(?=\S)/);
			for(let item of vals){
				if(item != ""){
					item = item.replace(/'/g, "\"");
					result = [...result, item];
				}
			}
			for(let [index, value] of result.entries()){
				result[index] = JSON.parse(value);
			}
		}
		return result;
	}

	const parseSANprop = (str) => str.split(",");
</script>

<div class="card">
    <div class="card-body p-0">
    	<table class="table table-bordered">
            <thead>
              <tr>
                <th>{$format("list.columns.name")}</th>
                <th >{$format("list.columns.value")}</th>
              </tr>
            </thead>
            <tbody>
                {#each data as item}
                    <tr>
                        <td>{item.name}</td>
						{#if item.value && !item.value.includes("data")}
							{#if item.name != 'cert_san'}
								<td>{item.value}</td>
							{:else}
								<td>
									{#each parseSANprop(item.value) as san}
										<div>{san}</div>
									{/each}
								</td>
							{/if}
						{:else}
							<td>
								{#each parseDeepObj(item.value) as itm}
									<div>{itm.name}: {itm.data}</div>
								{/each}
							</td>
						{/if}
		        	</tr>
                {/each}
            </tbody>
        </table>
      </div>
  </div>